import { NextSeo } from "next-seo";
import { PrivacyPolicy } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function PrivacyPolicyPage() {
  return (
    <LayoutWrapper>
      <NextSeo title="polityka prywatności nju | nju.pl" />
      <Header />
      <BlockContent spacing="l">
        <PrivacyPolicy />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
